"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerPanel = void 0;
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
/* Imported CSS */
require("./ContainerPanel.scss");
var ContainerPanel = function (props) { return (react_1.default.createElement("div", { className: "container-panel" },
    react_1.default.createElement("div", { className: classnames_1.default('container-panel-header', props.titleClassName) },
        react_1.default.createElement("p", { className: classnames_1.default('is-size-4', 'has-text-centered') }, props.title)),
    react_1.default.createElement("div", { className: classnames_1.default('container-panel-content', { loading: props.isLoading }) },
        react_1.default.createElement("div", { className: classnames_1.default('inner content', props.className) }, props.children)),
    react_1.default.createElement("div", { className: "container-panel-footer" },
        react_1.default.createElement("div", { className: "help-text has-text-centered" },
            react_1.default.createElement("p", null, "Don\u2019t have an account?"),
            react_1.default.createElement("p", null, "Please reach out to a Hasbro employee for an invitation."))))); };
exports.ContainerPanel = ContainerPanel;
